import common_words from '@/data/common_words.json'

/*
 * source: http://www.nsftools.com/misc/SearchAndHighlight.htm
 */

/*
 * This is the function that actually highlights a text string by
 * adding HTML tags before and after all occurrences of the search
 * term.
 */
const doHighlight = (bodyText, searchTerm) => {
  const highlightStartTag = "<font class='hklii-highlight'>";
  const highlightEndTag = "</font>";

  
  // find all occurences of the search term in the given text,
  // and add some "highlight" tags to them
  var newText = "";
  var i = -1;
  var termLen = 0
  // var lcSearchTerm = searchTerm.toLowerCase();
  var lcBodyText = bodyText.toLowerCase().replace(/[\u2018\u2019]/g, "'");
  
  while (bodyText.length > 0) {
    // i = lcBodyText.indexOf(lcSearchTerm, i + 1);
    [i, termLen] = regexIndexOf(lcBodyText, searchTerm, i + 1);
    if (i < 0) {
      newText += bodyText;
      bodyText = "";
    } else {
      // skip anything inside an HTML tag
      if (bodyText.lastIndexOf(">", i) >= bodyText.lastIndexOf("<", i)) {
        // skip anything inside a <script> block
        if (lcBodyText.lastIndexOf("/script>", i) >= lcBodyText.lastIndexOf("<script", i)) {
          newText += bodyText.substring(0, i) + highlightStartTag + bodyText.substr(i, termLen) + highlightEndTag;
          bodyText = bodyText.substr(i + termLen);
          lcBodyText = bodyText.toLowerCase();
          i = -1;
        }
      }
    }
  }
  return newText;
}

const regexIndexOf = (text, re, i) => {
  // var indexInSuffix = text.slice(i).search(re);
  const res = re.exec(text.slice(i))
  if(res){
    const indexInSuffix = res.index
    const len = res[0].length
    return [indexInSuffix + i, len]
  } else {
    return [-1, null]
  }
}


// const queryToKws2 = (query) => {
//   // change /m/ and /m,n/ operators to spaces
//   const proximitySlashRe = /\/[-?\d+\s?,?\s?\d*]+\//ig
//   query = query.replaceAll(proximitySlashRe, ' ')

//   const searchArray = query.split(' ')
//   const cleansedSearchArray = []
//   searchArray.forEach(term => {
//     term = term.toLowerCase()
  
//     // exclude terms that are boolean operators
//     const boolOpts = ['and', 'or', 'not']
//     if(boolOpts.includes(term)) return 
  
//     // exclude terms that areremove proximity operators (near w/n pre/n)
//     const proxOpts = /near|w\/\d+|pre\/\d+/
//     if (term.search(proxOpts) > 0) return

//     // remove title operators
//     const titleOpts = /title\((.*)\)|(.*)@title/
//     const matchTitle = titleOpts.exec(term)
//     if(matchTitle){term = matchTitle[1] || matchTitle[2]}

//     // remove non English, CJK, and *?'- characters in terms
//     // curly apostrophe is replaced with standard one in matching
//     const chiEngWild = /[^\w|\p{Han}?*'-+]/ig
//     term = term.replace(/[\u2018\u2019]/g, "'").replaceAll(chiEngWild, '')

//     // wildcards and special characters that should not be special
//     term = term.replaceAll('*', '\\w*')
//     term = term.replaceAll('?', '\\w')
//     term = term.replaceAll('+', '\\+')
//     term = term.replaceAll('-', '\\-')

//     var cleansedTerm = new RegExp(term)
//     if(cleansedTerm){cleansedSearchArray.push(cleansedTerm)}
//   })

//   return cleansedSearchArray
// }

const queryToKws = (query) => {
  const dbQuoteRe = /"(?:[^"\\]*(?:\\.[^"\\]*)*)"/ig
  let quotedStrs = [...query.matchAll(dbQuoteRe)].map(match => match[0].replaceAll('"', '').toLowerCase())
  let nonQuotedStrs = query.split(dbQuoteRe).filter(s => s).map(s => s.toLowerCase())
  
  const specialChars = ['\\', '^', '$', '{', '}', '[', ']', '.', '+', '|', '<', '>', '/']
  quotedStrs = quotedStrs.map(term => {
    specialChars.forEach(c => {
      term = term.replaceAll(c, '\\' + c)
    })
    term = term.replaceAll('*', '\\*')
    term = term.replaceAll('?', '\\?')
    term = term.replaceAll('(', '\\(')
    term = term.replaceAll(')', '\\)')
    return term
  })
  
  // exclude terms that are boolean operators
  const boolOpts = /(?:^|\s)(?:and|or|not)(?:$|\s)/
  nonQuotedStrs = Array.prototype.concat.apply([],
    nonQuotedStrs.filter(s => s).map(s => s.split(boolOpts))
  )

  // exclude terms that are proximity operators
  const proxOpts = /\s(?:near|w\/\d+|pre\/\d+)\s|\/[-?\d+\s?,?\s?\d*]+\//
  nonQuotedStrs = Array.prototype.concat.apply([],
    nonQuotedStrs.filter(s => s).map(s => s.split(proxOpts))
  )
  
  // remove title operators
  const titleOpts = /title\((.*)\)|(.*)@title/
  nonQuotedStrs = nonQuotedStrs.filter(s => s).map(s => {
    const matchTitle = titleOpts.exec(s)
    return matchTitle ? s.replace(matchTitle[0], matchTitle[1] || matchTitle[2]) : s
  })

  nonQuotedStrs = nonQuotedStrs.map(term => {
    term = term.replace(/[\u2018\u2019]/g, "'").trim().toLowerCase()
    // wildcards and special characters that should not be special
    specialChars.forEach(c => {
      term = term.replaceAll(c, '\\' + c)
    })
    term = term.replaceAll('*', '[\\w\\p{Script=Han}]*')
    term = term.replaceAll('?', '[\\w\\p{Script=Han}]')
    term = term.replaceAll('(', '\\(?')  // brackets are optional in non-quoted strings
    term = term.replaceAll(')', '\\)?')

    // make common words optional
    let term_segments = term.split(' ')
    term = ''
    term_segments.forEach((seg, idx, arr) => {
      if(common_words.includes(seg)){
        term = term + '(?:' + seg + '\\s?)?'  // non-capturing optional group
      } else {
        term = term + seg
        if (idx != arr.length - 1){  // not last item
          term = term + '\\s'
        }
      }
    })
    return term
  })
  let terms = [...quotedStrs, ...nonQuotedStrs]
  terms = terms.map(
    term => {
      try{
        return new RegExp(term, 'u')
      } catch (error){
        console.log(error)
        return ''
      }
    }
  ).filter(r => !(''.match(r) || ' '.match(r)))  // prevent attempting highlighting empty strings
  return terms
}

const hlBody = (content, query) => {
  var keywords = queryToKws(query)
  var highlighted = content
  keywords.forEach(kw => {
    highlighted = doHighlight(highlighted, kw)
  })
  return highlighted
}


export default {
  hlBody,
  queryToKws
}
